module.exports = __webpack_public_path__ + "img/188-2e1582.png";